import { render, staticRenderFns } from "./Grommings.vue?vue&type=template&id=30012588&scoped=true"
import script from "./Grommings.vue?vue&type=script&lang=js"
export * from "./Grommings.vue?vue&type=script&lang=js"
import style0 from "./Grommings.vue?vue&type=style&index=0&id=30012588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30012588",
  null
  
)

export default component.exports